import { memo } from 'react';
import { Card, Icon, Text, Tooltip } from '@shopify/polaris';
import { InfoIcon } from '@shopify/polaris-icons';
import { StyledStatisticsCard } from './styled';

interface StatisticCardProps {
  icon: JSX.Element;
  title: string;
  description: string;
  quantity: number;
}

const StatisticCard = ({ icon, title, description, quantity }: StatisticCardProps) => {
  return (
    <StyledStatisticsCard>
      <Card>
        <div className="statistics-row">
          {icon}
          <div className="statistics-right">
            <div className="statistics-content">
              <Text variant="bodyLg" as="p">
                {title}
              </Text>
              <Tooltip content={description}>
                <Icon source={InfoIcon} tone="base" />
              </Tooltip>
            </div>
            <Text variant="headingLg" as="h4">
              {quantity}
            </Text>
          </div>
        </div>
      </Card>
    </StyledStatisticsCard>
  );
};

export default memo(StatisticCard);
